import React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import data from '../data/paomakeup';
import { useFetch } from '../hooks/useApiCall';
import { getCategories } from '../services/serviceService';
import { mapCategoriesToPriceData } from '../utils/dataMappers';
import { PmLoading, PmError } from '../components/pm/PmStates';
import { IconArrow } from '../components/pm/PmIcons';

const PriceRows = ({ services }) => (
  services.map((item, idx) => (
    <div className="price-row" key={idx}>
      <span>{item.name}</span>
      <span className="price-row__price">{item.price}</span>
    </div>
  ))
);

const OurServicesPrices = () => {
  const { data: apiCategories, loading, error, refetch } = useFetch(getCategories);

  const priceData = apiCategories
    ? mapCategoriesToPriceData(apiCategories)
    : data.our_services_price;

  return (
    <div className="pm-scope page">
      <Helmet>
        <title>{data.our_services_price_title} - {data.title}</title>
        <meta name="description" content={data.our_services_price_description} />
        <meta name="keywords" content={data.our_services_price_keywords} />
        <meta property="og:title" content={data.our_services_price_title} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.pmbeautystudio.com/nuestros-servicios/precios" />
        <meta property="og:site_name" content="PaoMakeup Beauty Studio" />
        <meta property="og:description" content={data.our_services_price_description} />
      </Helmet>

      <section className="section">
        <div className="container">
          <div className="section-head section-head--center">
            <span className="eyebrow eyebrow--center">Precios</span>
            <h1 className="text-balance">Conoce nuestros servicios y precios</h1>
            <p>Toca una categoría para ver el detalle y agendar los servicios que quieras.</p>
          </div>

          {loading && <PmLoading message="Cargando los precios…" />}
          {error && !apiCategories && <PmError message={error} onRetry={refetch} />}

          {!loading && priceData && priceData.length > 0 && (
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 1100: 3 }}>
              <Masonry gutter="20px">
                {priceData.map((service, index) => (
                  <Link
                    key={service.service_slug || index}
                    to={`/nuestros-servicios/${service.service_slug}/precios`}
                    className="price-card"
                  >
                    <div className="price-card__head">
                      <span>{service.service_name}</span>
                      <IconArrow />
                    </div>
                    <div className="price-card__body">
                      {service.sub_services ? (
                        service.sub_services.map((sub, subIndex) => (
                          <div key={subIndex}>
                            {sub.sub_service_name && (
                              <p className="price-group__name">{sub.sub_service_name}</p>
                            )}
                            {sub.description && (
                              <p className="price-group__desc">{sub.description}</p>
                            )}
                            <PriceRows services={sub.services} />
                          </div>
                        ))
                      ) : (
                        service.services && <PriceRows services={service.services} />
                      )}
                    </div>
                  </Link>
                ))}
              </Masonry>
            </ResponsiveMasonry>
          )}
        </div>
      </section>
    </div>
  );
};

export default OurServicesPrices;
